import { useEffect, useState } from "react";

/**
 * useInViewport — returns [ref, inView] using IntersectionObserver.
 * Pass the returned ref to any DOM element; `inView` flips true when at least
 * `threshold` of the element is on-screen. Used by landing carousels to pause
 * autoplay timers when scrolled off-screen (saves battery on mobile + avoids
 * silently rotating content the visitor can't see).
 */
export default function useInViewport(threshold = 0.2) {
  const [el, setEl] = useState(null);
  const [inView, setInView] = useState(true);

  useEffect(() => {
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [el, threshold]);

  return [setEl, inView];
}
